import { Component, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { BehaviorSubject } from "rxjs";

import { SingleChoice } from "../../../model/singlechoice";
import { DependentChoice } from "../../../model/dependentchoice";
import { NavigationHelper } from "../../../services/navigation.helper";
import { Navigation } from "../../../model/navigation";
import { FilterService } from "../../../services/filter.service";
import { SettingsService } from "../../../services/settings.service";

@Component({
  selector: "frame-tablet",
  templateUrl: "./frame-tablet.component.html",
  styleUrls: ["./frame-tablet.component.css"],
})
export class FrameTabletComponent {
  isMenuOpen = false;
  current_topic: BehaviorSubject<string> = new BehaviorSubject<string>("");
  current_choice: BehaviorSubject<SingleChoice> = new BehaviorSubject(SingleChoice.EMPTY);
  current_dependent: BehaviorSubject<DependentChoice> = new BehaviorSubject(DependentChoice.EMPTY);
  currentNavigation: Navigation;
  showDependentsOnly = false;
  showFilterForTicket = false;
  selectedTicketId: number | null = null;
  showListByBranch = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navigation: NavigationHelper,
    private filterservice: FilterService,
    private cdRef: ChangeDetectorRef,
    private settingsService: SettingsService
  ) {
    this.currentNavigation = new Navigation("", "", "", null, null);
  }
  currentFilter: any = null;
 ngOnInit(): void {
    this.settingsService.get<boolean>("showListByBranch", false).subscribe((value) => {
      this.showListByBranch = value;
    });

    this.filterservice.filterObservable.subscribe((filter) => {
      this.currentFilter = filter;
      this.cdRef.detectChanges();
    });

    this.route.params.subscribe((params) => {
      const topic = params["id"] || "tickets";
      this.current_topic.next(topic);
      this.cdRef.detectChanges();
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateCurrentTopicFromUrl();
      }
    });

    this.updateCurrentTopicFromUrl();

    this.navigation.topic.subscribe((topic) => {
      if (topic) {
        this.current_topic.next(topic);
      }
    });

    this.navigation.singlechoice.subscribe((choice) => {
      this.relaySingleChoice(choice);
    });

    this.updateCurrentTopicFromUrl();
  }

   updateCurrentTopicFromUrl(): void {
    const nav = this.navigation.freshNavigation;

    this.showFilterForTicket = nav.action.includes("filter");

    if (nav.action.includes("choose")) {
      const choice = this.navigation.currentChoice;
      if (choice && choice !== SingleChoice.EMPTY) {
        this.current_choice.next(choice);
        this.showDependentsOnly = true;
      } else {
        this.current_choice.next(SingleChoice.EMPTY);
        this.showDependentsOnly = false;
      }
    } else {
      this.showDependentsOnly = false;
    }

    if (nav.topic) {
      this.current_topic.next(nav.topic);
    }

    if (nav.action.includes("fragmentedit")) {
    } else if (nav.action.includes("fragment")) {
    } else if (nav.action.includes("edit")) {
    } else if (nav.action.includes("multi-process")) {
    } else if (nav.action.includes("result")) {
    }

    this.currentNavigation = nav;
  }


  selectItem(event: string): void {
    this.current_topic.next(event);
    this.showDependentsOnly = false;
    this.isMenuOpen = false;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  selectTicket(ticketId: number): void {
    this.selectedTicketId = ticketId;
    this.showFilterForTicket = false;
      this.isMenuOpen = false;
  }

  toggleFilterForTicket(): void {
    this.showFilterForTicket = !this.showFilterForTicket;
    if (this.showFilterForTicket) {
      this.selectedTicketId = null;
    }
  }

   relaySingleChoice(choice: SingleChoice) {
    this.current_choice.next(choice);
    this.showDependentsOnly = true;
    if (this.selectedTicketId !== null) {
      this.navigation.freshNavigation.id = this.selectedTicketId.toString();
      this.navigation.freshNavigation.action = "edit";
    }

    if (this.selectedTicketId !== null) {
      this.reloadDetails(this.selectedTicketId);
    }


    this.cdRef.detectChanges();

    choice.waiting.subscribe(() => {
      this.current_choice.next(SingleChoice.EMPTY);
      this.showDependentsOnly = false;

      if (this.selectedTicketId !== null) {
        this.navigation.freshNavigation.id = this.selectedTicketId.toString();
        this.navigation.freshNavigation.action = "edit";
        this.reloadDetails(this.selectedTicketId);
      }

      this.cdRef.detectChanges();
    });
  }

 get topic() {
    return this.currentNavigation.topic;
  }

  get choosing(): boolean {
    const c = this.current_choice.value;
    return c && c !== SingleChoice.EMPTY;
  }

  get chooseTopic(): string {
    return this.choosing ? this.current_choice.value.topic : "";
  }

  get currentChoice(): SingleChoice {
    const sc = this.current_choice.value;

    return sc ? sc : SingleChoice.EMPTY;
  }
  get currentNav(): Navigation {
    const nav = this.navigation.current;
    if (nav) {
      return nav;
    } else {
      return this.currentNavigation;
    }
  }
  reloadDetails(ticketId?: number) {
    if (ticketId) this.selectedTicketId = ticketId;

    const nav = this.navigation.freshNavigation;
    this.currentNavigation = nav;

    const choice = this.navigation.currentChoice;
    this.showDependentsOnly = choice && choice !== SingleChoice.EMPTY;

    if (nav.topic) this.current_topic.next(nav.topic);

    this.cdRef.detectChanges();
  }

  isTopicEmpty(): boolean {
    return !this.current_topic.value || this.current_topic.value.trim() === "";
  }
}
